let $popup = $('.popup')
let $body = $('body')
let $html = $('html')

function closePopup()
{
  $popup.removeClass('popup-visible')
  $html.removeClass('popup-open')
  $popup.find('.js-popup-content').html('')
  $popup.attr('data-content', '')
}

function openPopup(popupContent)
{
  let $popupContentHTML = $('[data-popup-content="'+popupContent+'"]').html()

  if($popupContentHTML && $popupContentHTML.length) {
    $popup.find('.js-popup-content').html($popupContentHTML)
    $popup.attr('data-content', popupContent)
    $popup.addClass('popup-visible')
    $html.addClass('popup-open')
  }

}

$body.on('click', '[data-js-open-popup-content]', function (e){
  e.preventDefault()
  openPopup($(this).attr('data-js-open-popup-content'))
})

$body.on('click', '.js-close-popup, .js-background-popup', function (e){
  e.preventDefault()
  closePopup()
})

$(document).keyup(function(e) {
  if (e.key === "Escape" && $popup.is(':visible')) { // escape key maps to keycode `27`
    closePopup()
  }
});
